import { useTheme } from "@emotion/react";
import AccountCircleOutlinedIcon from "@mui/icons-material/AccountCircleOutlined";
import FacebookIcon from "@mui/icons-material/Facebook";
import GoogleIcon from "@mui/icons-material/Google";
import LogoutIcon from "@mui/icons-material/Logout";
import { Avatar, Box, Divider, ListItemIcon, ListItemText, MenuItem, Typography } from "@mui/material";
import React, { useCallback, useContext } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { UserContext } from "../../contexts/UserContext";
import { facebookSignIn, googleSignIn, logout } from "../../services/authService";
import { menuItem, userAvatar, userInfoBox, userInfoContainer } from "../../styles/dropdownStyles";
import Dropdown from "../Common/Dropdown";

const UserDropdown = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { user, setUser } = useContext(UserContext);
  const theme = useTheme();

  const handleProviderLogin = useCallback(
    async (providerSignIn, providerName) => {
      try {
        const user = await providerSignIn();
        setUser(user);
      } catch (error) {
        console.error(`${providerName} Login failed:`, error);
      }
    },
    [setUser]
  );

  const handleLogout = useCallback(async () => {
    try {
      await logout(navigate);
      setUser(null);
    } catch (error) {
      console.error("Logout Error:", error);
    }
  }, [setUser, navigate]);

  return (
    <Dropdown
      icon={user ? <AccountCircleOutlinedIcon /> : <Typography variant="body1">{t("login")}</Typography>}
      buttonProps={{
        color: "inherit",
        "aria-label": user ? t("profile") : t("login"),
      }}
    >
      {user ? (
        // Logged in user menu
        <>
          <Box sx={userInfoContainer}>
            <Box sx={userInfoBox}>
              {user.photoURL ? <Avatar src={user.photoURL} alt={user.displayName} sx={userAvatar} /> : <AccountCircleOutlinedIcon sx={userAvatar} />}
              <Box>
                <Typography variant="subtitle1">{user.displayName}</Typography>
                <Typography variant="body2" color="textSecondary">
                  {user.email}
                </Typography>
              </Box>
            </Box>
          </Box>
          <Divider />
          <MenuItem onClick={handleLogout} sx={menuItem(theme)}>
            <ListItemIcon>
              <LogoutIcon fontSize="small" />
            </ListItemIcon>
            <ListItemText primary={t("logout")} />
          </MenuItem>
        </>
      ) : (
        // Login menu
        <>
          <MenuItem onClick={() => handleProviderLogin(googleSignIn, "Google")} sx={menuItem(theme)}>
            <ListItemIcon>
              <GoogleIcon fontSize="small" />
            </ListItemIcon>
            <ListItemText primary={t("signInWithGoogle")} />
          </MenuItem>
          <MenuItem onClick={() => handleProviderLogin(facebookSignIn, "Facebook")}>
            <ListItemIcon>
              <FacebookIcon fontSize="small" />
            </ListItemIcon>
            <ListItemText primary={t("signInWithFacebook")} />
          </MenuItem>
        </>
      )}
    </Dropdown>
  );
};

export default UserDropdown;
